import React, {Component} from 'react';
import {ChannelLogo} from "../channels/ChannelLogo";

class AdAccountsItems extends Component {

    //this.props.adAccountsSelectedItemsData = AdAccountsActionDataHandler

    renderAdAccountItemsDetails(channel, items, empty_items_item) {
        // items: [name], empty_items_item:{"text":, "is_ok": False/True}
        if(items.length === 0) {
            return <div className={`empty_items_item ${(empty_items_item["is_ok"] === true ? "ok" : "not-ok")}`}>{empty_items_item["text"]}</div>;
        } else {
          const result = items.slice(0, 5).map((item) => (<div className={`item ${channel.toLowerCase()}`}><i className={`fa fa-check`} aria-hidden="true"/>{item}</div>));
          if(items.length > 5) {
              result.push(<div className={`item ${channel.toLowerCase()}`}><i className={`fa fa-check`} aria-hidden="true"/>Y más...</div>);
          }
            return result;
        }
    }

    renderAdAccountHeader(channel, account_id, name) {
        return <div className={"ad_account-header"}><ChannelLogo hspace={0} vspace={0} channel={channel}/>{`${name} (Id: ${account_id})`}</div>
    }

    renderAdAccountsItems() {
        if(this.props.adAccountsSelectedItemsData === undefined)
            return null;
        return this.props.adAccountsSelectedItemsData.map(adAccountSelectedItemsData => (this.renderAdAccountItems(adAccountSelectedItemsData)));
    }

    renderAdAccountItems(adAccountSelectedItemsData) {
        // adAccountSelectedItemsData =  {ad_account_id, ad_account_account_id, ad_account_name, channel, items: [name], empty_items_item:{"text":, "is_ok": False/True}
        return <div className={"ad-account"}>
            {this.renderAdAccountHeader(adAccountSelectedItemsData["channel"], adAccountSelectedItemsData["ad_account_account_id"], adAccountSelectedItemsData["ad_account_name"])}
            <div className={"ad-accounts-items"}>
                {this.renderAdAccountItemsDetails(adAccountSelectedItemsData["channel"], adAccountSelectedItemsData["items"], adAccountSelectedItemsData["empty_items_item"])}
            </div>
        </div>

    }

    render() {
        return (
            <div className="ad-accounts-items-read_only-table">
                {this.renderAdAccountsItems()}
            </div>
        );
    }
}

export default AdAccountsItems;
